<script>
import { Bubble, mixins } from 'vue-chartjs'

const {reactiveData} = mixins

function formatTs (ts) {
  let d = new Date(parseInt(ts))
  let m = d.getMinutes()
  let h = d.getHours()

  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  return h + ':' + m
}

const getChartOptions = timescale => ({
  maintainAspectRatio: true,
  legend: {
    display: false
  },
  tooltips: {
    callbacks: {
      label: tooltipItem => formatTs(tooltipItem.xLabel)
    }
  },
  scales: {
    yAxes: [
      {
        display: false
      }
    ],
    xAxes: [
      {
        type: 'time',
        distribution: 'linear',
        time: {
          tooltipFormat: 'x',
          displayFormats: {
            hour: 'HH:mm'
          },
          min: new Date().getTime() - timescale * 60 * 60 * 1000,
          max: new Date().getTime(),
          minUnit: 'hour',
          stepSize: 1
        }
      }
    ]
  }
})

export default {
  name: 'AlarmTimeline',
  extends: Bubble,
  mixins: [reactiveData],
  props: {
    alarms: Array,
    timescale: Number
  },
  data () {
    return {
      options: getChartOptions(this.timescale)
    }
  },
  watch: {
    timescale: {
      handler(newTimescale) {
        this.options = getChartOptions(newTimescale);
        this.renderChart(this.chartData, this.options);
      }
    },
    alarms: {
      immediate: true,
      handler (newAlarms) {
        this.chartData = {
          datasets: [
            {
              backgroundColor: '#FF595A',
              data: newAlarms
            }]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
